import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import KioskView from '../housekiosk/components/Kiosk/KioskView';
import { UserContext } from '../contexts/UserContext';

export default function HouseKioskKioskPage() {
  const { userProfile } = useContext(UserContext);
  const role = (userProfile?.mainRole || '').toUpperCase();
  const isKiosk = role.includes('KIOSK');

  if (!isKiosk) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <KioskView />;
}
